module.exports = __webpack_public_path__ + "static/media/march'24.2a207900.svg";